import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Money } from '@clari/ui'
import type { TransactionDto } from '@/lib/types'

function TransactionItem({ tx, locale }: { tx: TransactionDto; locale: string }) {
  const { t } = useTranslation('banking')
  const typeLabel = t(`transactions.type.${tx.type}`, { defaultValue: tx.type })
  return (
    <li>
      <Link
        to={`/app/transactions/${tx.id}`}
        className="flex items-center justify-between gap-3 border-b border-border py-3 last:border-0 hover:bg-bg-subtle"
      >
        <span className="min-w-0">
          <span className="block truncate text-sm font-medium">
            {tx.counterparty_name ?? typeLabel}
          </span>
          <span className="block truncate text-xs text-text-muted">{typeLabel}</span>
        </span>
        <Money amountCents={tx.amount_cents} currency={tx.currency} locale={locale} showSign />
      </Link>
    </li>
  )
}

export function TransactionList({ items, locale }: { items: TransactionDto[]; locale: string }) {
  const { t } = useTranslation('banking')
  if (items.length === 0) {
    return <p className="text-sm text-text-muted">{t('transactions.empty')}</p>
  }
  return (
    <ul className="flex flex-col">
      {items.map((tx) => (
        <TransactionItem key={tx.id} tx={tx} locale={locale} />
      ))}
    </ul>
  )
}
